import { useState, useEffect } from "react";
import { Frame, Loading, Header, Input, ValidaUid } from "../components";
import { useNavigate } from "react-router-dom";
import { db, auth, storage } from "../config/firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
import { Image, Modal, Button } from "react-bootstrap";
import IconeVinculo from "../assets/vinculo.png";
import moment from "moment";

const Vinculo = () => {
  const [dados, setDados] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const [loading, setLoading] = useState(true);

  let uid = auth.currentUser?.uid;

  const navigate = useNavigate();

  const uploadFile = async (file, docPath, docUrl) => {
    if (!file) return;

    setLoading(true);

    const path = ref(storage, `furg2026/${uid}/${docPath}`);

    const upload = uploadBytesResumable(path, file, file.type);

    upload.on(
      "state_changed",
      () => {},
      () => {},
      () => {
        getDownloadURL(upload.snapshot.ref).then((url) => {
          setDados({ ...dados, [docUrl]: url });
          setLoading(false);
        });
      },
    );
  };

  const setData = async () => {
    await setDoc(
      doc(db, "furg2026", uid),
      { ...dados, dataVinculo: moment().format() },
      { merge: true },
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      await setData();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setModalShow(true);
    }
  };

  const buscaDados = async () => {
    const uid = await ValidaUid();

    if (uid) {
      const qry = await getDoc(doc(db, "furg2026", uid));

      const data = qry.data();

      if (data?.status === "a" && data?.contrato === "2026") {
        setDados(data);
        setLoading(false);
      } else navigate("../home");
    }
  };

  const fechaModal = () => {
    setModalShow(false);
  };

  useEffect(() => {
    buscaDados();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading && <Loading />}
      <Header nome={dados?.nome} foto={dados?.urlFoto} />
      <Frame
        body={
          <form
            autoComplete="off"
            onSubmit={handleSubmit}
            className="text-start px-5 py-4"
            noValidate
          >
            <Image
              src={IconeVinculo}
              alt="Imagem"
              height={300}
              className="d-block mx-auto"
            />

            <div className="text-center">
              Por gentileza, mantenha seu comprovante de vínculo atualizado.
            </div>

            {dados?.dataVinculo && (
              <div className="mt-3 text-end">
                <i>
                  Data da última atualização:{" "}
                  {moment(dados.dataVinculo).format("DD/MM/YY HH:mm:ss")}
                </i>
              </div>
            )}

            <div className="row mt-3">
              <div className="col-sm-12">
                <Input
                  id="imgVinculo"
                  label={"Comprovante de Vínculo"}
                  type="file"
                  accept=".jpg, .jpeg, .png, .pdf"
                  onChange={(e) =>
                    uploadFile(e.target.files[0], "vinculo", "urlVinculo")
                  }
                />
              </div>
              {dados?.urlVinculo && (
                <a
                  href={dados?.urlVinculo}
                  target="_blank"
                  rel="noreferrer"
                  className="dark m-2"
                >
                  🔎 Ver documento enviado
                </a>
              )}
            </div>

            <div className="row mt-3">
              <div className="col-sm-12 d-grid">
                <button type="submit" className="btn btn-primary">
                  ENVIAR
                </button>
              </div>
            </div>
          </form>
        }
        title="Atualizar Comprovante de Vínculo"
      />

      <Modal show={modalShow} onHide={fechaModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Atenção!</Modal.Title>
        </Modal.Header>
        <Modal.Body>Comprovante atualizado com sucesso!</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={fechaModal}>
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Vinculo;
